import { render, staticRenderFns } from "./CianCardElementConfigurableScaleEditDialog.vue?vue&type=template&id=b2b68fa8"
import script from "./CianCardElementConfigurableScaleEditDialog.vue?vue&type=script&lang=js"
export * from "./CianCardElementConfigurableScaleEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports